import { render, staticRenderFns } from "./FoodCategory.vue?vue&type=template&id=41f13db7&scoped=true&"
import script from "./FoodCategory.vue?vue&type=script&lang=js&"
export * from "./FoodCategory.vue?vue&type=script&lang=js&"
import style0 from "./FoodCategory.vue?vue&type=style&index=0&id=41f13db7&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f13db7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FoodItem: require('/opt/build/repo/components/Food/FoodItem.vue').default,FoodPush: require('/opt/build/repo/components/Food/FoodPush.vue').default})
